"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = require("./Query");
var BaseQuery_1 = require("./BaseQuery");
var dataset_1 = require("../models/api/dataset");
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var typeChecks_1 = require("../utils/typeChecks");
var DatasetQuery = /** @class */ (function (_super) {
    __extends(DatasetQuery, _super);
    function DatasetQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatasetQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, key = _a.key, index = _a.index, collectionItemConditional = _a.collectionItemConditional, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ key: key,
            index: index,
            collectionItemConditional: collectionItemConditional }, (options.dataset || {}));
    };
    DatasetQuery.prototype.getRawValue = function (executionOptions) {
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        var _a = this.options, datasetKey = _a.datasetKey, queryKey = _a.queryKey, key = _a.key, index = _a.index, collectionItemConditional = _a.collectionItemConditional, _b = _a.returnFullQuery, returnFullQuery = _b === void 0 ? false : _b;
        var dataset = this.getDataset(context, datasetKey);
        if (dataset) {
            var query = dataset.queries.find(function (query) { return query.key === queryKey; });
            if (query) {
                var results = query.results, type = query.type;
                if (Array.isArray(results) && results.length > 0) {
                    if (key && type === dataset_1.QueryOutputType.arrayOfObjects) {
                        results = results.map(function (r) { return r[key]; });
                    }
                    if (!typeChecks_1.isNullOrUndefined(index) && index < results.length) {
                        results = results[index];
                    }
                    else if (collectionItemConditional) {
                        var conditionalHelper_1 = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
                        results = results.filter(function (item) { return conditionalHelper_1.matches(item, collectionItemConditional, executionOptions); });
                    }
                }
                if (!returnFullQuery) {
                    return results;
                }
                return query;
            }
        }
    };
    DatasetQuery.prototype.getDataset = function (context, datasetKey) {
        if (context && context.datasets) {
            return context.datasets[datasetKey];
        }
    };
    return DatasetQuery;
}(BaseQuery_1.BaseQuery));
exports.DatasetQuery = DatasetQuery;
//# sourceMappingURL=DatasetQuery.js.map